import StaticPageRedirect from '../component/StaticPageRedirect';
export default function About() { return <StaticPageRedirect page="about" />; }
